import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInterruptStructures = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Interrupt Structures: Vectored and Prioritized"
      videos={[
        "https://www.youtube.com/embed/1aG3aFEKxyA"
      ]}
      takeaways={[
        { text: "Learn everything mentioned in the video." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicInterruptStructures;
